import { render, staticRenderFns } from "./SessionEndResumeBubble.vue?vue&type=template&id=c90a3dc4&scoped=true&"
import script from "./SessionEndResumeBubble.vue?vue&type=script&lang=js&"
export * from "./SessionEndResumeBubble.vue?vue&type=script&lang=js&"
import style0 from "./SessionEndResumeBubble.vue?vue&type=style&index=0&id=c90a3dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90a3dc4",
  null
  
)

export default component.exports